import { Autocomplete, Box, Checkbox, FormControlLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalButton from "../../../utils/GlobalButton";
import axiosInstance from "../../../utils/axiosInstance";
import { fetchgeneral, Generalconfig } from "../../shared/ApiEndpoint";
import { notification } from "antd";
import { RETRYSWITCHOPTIONS, SLASHSTARTERS, TEMPLATEMESSAGELIMIT } from "../../shared/Constant";

const General = ({ botId,bots_type }) => {
  const [general, setGeneral] = useState({
    agentic_ai_url: "",
    session_Expiry: 0,
    retry_count: 0,
    retry_switch:"",
    is_direct_botFlow: false,
    is_support_true:false,
    is_start_true:false,
    is_reset_true:false,
    is_user_initiate:false,
    is_multilingual_true:false,
    loop_bot_flow:false,
    templatemessagelimit:{type:"",limit:0},
    consecutivemsglimit:0
  });

  useEffect(()=>{
    fetchGeneralConfig()
  },[])

  const handleOnChange = (e) => {
    // const { name, value } = e.target;
    // setGeneral({ ...general, [name]: value }); // 🔁 use general instead of newUser

  const { name, type, value, valueAsNumber } = e.target;

  setGeneral(prev => ({
    ...prev,
    [name]:
      type === "number"
        ? value === "" ? 0 : valueAsNumber
        : value,
  }));
  };

  const fetchGeneralConfig =async ()=>{
    try {
      const resp= await axiosInstance.post(fetchgeneral,{
        bot_id:botId,
        ...(bots_type && bots_type !== "all" && { bots_type: bots_type }),
      },{
        withCredentials:true
      })
      const data= resp.data;
      if(resp.status === 200){
        setGeneral(data)
      }
    } catch (error) {
      console.log(error);
    }
  }
  const handlesaveGeneral = async () => {
    const payload = {
      bot_id: botId,
      ...(general && {...general}),
      ...(bots_type && bots_type !== "all" && { bots_type: bots_type }),
    };

    try {
      const res = await axiosInstance.post(Generalconfig, payload, {
        withCredentials: true,
      });
      if (res.status === 200) {
        console.log("saved");
         notification.success({
                  key: 'bot-config-save-success', 
                  description: 'Bot General saved successfully!',
                  placement: 'topRight',
                });
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(general,"general")
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-3">
            <TextField
              fullWidth
              label="Retry Count"
              placeholder="Enter retry count..."
              name="retry_count"
              type="number"
              value={general.retry_count}
              onChange={handleOnChange}
            />
          </div>

          <div className="col-md-4">
            <TextField
              fullWidth
              label="Session Expiry Minutes"
              placeholder="Enter Expiry Minutes..."
              name="session_Expiry"
              type="number"
              value={general.session_Expiry}
              onChange={handleOnChange}
            />
          </div>
           <div className="col-md-4">
            <Autocomplete
                        options={RETRYSWITCHOPTIONS.map((opt)=>opt.id)}
                        value={general.retry_switch}
                        // onChange={handleAutoCompleteChange(setAdmins, "adminInputArray")} // Store only IDs
                        onChange={(e, newRetryValue) => setGeneral((prev)=>({...prev,retry_switch:newRetryValue}))}
                        renderTags={() => null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Support"
                            placeholder="Support"
                          />
                        )}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                      />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <TextField
              fullWidth
              label="Agentic Ai Url"
              placeholder="Enter Agentic Ai Url..."
              name="agentic_ai_url"
              value={general.agentic_ai_url}
              onChange={handleOnChange}
            />
          </div>

         <div className="col-md-4 mb-3">
  <FormControlLabel
    control={
      <Checkbox
        checked={general.is_direct_botFlow}
        name="is_direct_botFlow"
        onChange={(e) =>
          setGeneral((prev) => ({
            ...prev,
            is_direct_botFlow: e.target.checked,
          }))
        }
      />
    }
    label="Skip Auth Flow"
  />
</div>

 <div className="col-md-2 mb-3">
            <TextField
              fullWidth
              label=" Consecutive Msg Limitation"
              placeholder="Enter Limitation..."
              name="consecutivemsglimit"
              type="number"
              value={general.consecutivemsglimit}
              onChange={handleOnChange}
            />
          </div>
        </div>


        <div className="row">

{SLASHSTARTERS.map((item,index)=>(
  
         <div className="col-md-4 mb-3">
  <FormControlLabel
    control={
      <Checkbox
        checked={general[item.label]}
        name={item.label}
        onChange={(e) =>
          setGeneral((prev) => ({
            ...prev,
            [item.label]: e.target.checked,
          }))
        }
      />
    }
    label={item.name}
  />
</div>
))}
        </div>
        <div className="row">
<div className="col-md-6">

  <Autocomplete
  options={TEMPLATEMESSAGELIMIT}
  getOptionLabel={(option) => option.name}
  value={
    TEMPLATEMESSAGELIMIT.find(
      (opt) => opt.id === general?.templatemessagelimit?.type
    ) || null
  }
  onChange={(e, newValue) =>
    setGeneral((prev) => ({
      ...prev,
      templatemessagelimit: {
        ...prev.templatemessagelimit,
        type: newValue ? newValue.id : ""
      }
    }))
  }
  renderInput={(params) => (
    <TextField {...params} label="Limit Type" placeholder="Select limit type" />
  )}
/>
</div>
<div className="col-md-6">
  
{general?.templatemessagelimit?.type && general?.templatemessagelimit?.type!=="noLimit" && (
  <TextField
    type="number"
    label={`Enter ${general.templatemessagelimit.type} limit`}
    placeholder="Enter limit"
    value={general?.templatemessagelimit?.limit}
    onChange={(e) =>
      setGeneral((prev) => ({
        ...prev,
        templatemessagelimit: {
          ...prev.templatemessagelimit,
          limit: Number(e.target.value)
        }
      }))
    }
    fullWidth
    // sx={{ mt: 2 }}
    inputProps={{ min: 1 }}
  />
)}
</div>
        </div>
      </div>

      <Box display="flex" justifyContent="flex-end" mb={3}>
        <GlobalButton
          children={"Save"}
          size="sm"
          variant="contained"
          onClick={() => handlesaveGeneral()}
        />
      </Box>
    </>
  );
};

export default General;
